import mantangLogoUrl from '@/assets/svgs/mantang-logo-mono.svg';

type CreateStationMarkerHtmlParams = {
	price?: number;
	savings?: number;
	isSelected?: boolean;
	stationLogo?: string | null;
	label?: string;
};

const STATION_LOGO_SIZE = 14;
const STATION_LOGO_GAP = 4;

const getStationLogoUrl = (stationLogo?: string | null) => {
	if (!stationLogo) return mantangLogoUrl;
	if (/^https?:\/\//.test(stationLogo)) return stationLogo;

	const normalizedPath = stationLogo.startsWith('station-logos/')
		? stationLogo
		: `station-logos/${stationLogo}`;
	const cdnBaseUrl = import.meta.env.VITE_CDN_BASE_URL ?? '';

	return `${cdnBaseUrl}/${normalizedPath}`;
};

const createStationMarkerHtml = ({
	price,
	savings,
	isSelected = false,
	stationLogo,
	label,
}: CreateStationMarkerHtmlParams): string => {
	const bgColor = isSelected ? '#FFC342' : 'white';
	const priceColor = isSelected ? '#1a1a1a' : '#1f2937';
	const savingsColor = isSelected ? '#505967' : '#fbbf24';
	const labelBgColor = isSelected ? '#1f2937' : '#41915E';
	const stationLogoUrl = getStationLogoUrl(stationLogo);

	const priceContent = price
		? `<div style="display:flex;align-items:center;gap:${STATION_LOGO_GAP}px;">
				<img
					aria-hidden="true"
					src="${stationLogoUrl}"
					data-fallback="${mantangLogoUrl}"
					onerror="this.onerror=null;this.src=this.dataset.fallback"
					width="${STATION_LOGO_SIZE}"
					height="${STATION_LOGO_SIZE}"
					style="display:inline-block;flex:none;object-fit:contain;"
				/>
				<span style="font-size:14px;font-weight:600;color:${priceColor};">${price.toLocaleString()}원</span>
			</div>`
		: `<div style="display:flex;flex-direction:column;align-items:center;gap:4px;">
				<div style="width:56px;height:14px;border-radius:4px;background:#e3e4e7;"></div>
				<div style="width:40px;height:10px;border-radius:4px;background:#e3e4e7;"></div>
			</div>`;

	const savingsHtml =
		price && savings && savings > 0
			? `<span style="font-size:10px;color:${savingsColor};">예상 ${savings.toLocaleString()}원 절약</span>`
			: '';

	// FIXME: 마커가 특정 상황에서 세로로 길어지는 문제 수정 필요.

	return `
		<div style="display:flex;flex-direction:column;align-items:center;">
			${
				label
					? `<div style="margin-bottom:4px;border-radius:999px;background:${labelBgColor};padding:3px 8px;color:white;font-size:10px;font-weight:600;line-height:1;box-shadow:0 2px 8px rgba(0,0,0,0.14);white-space:nowrap;">${label}</div>`
					: ''
			}
			<div style="display:flex;flex-direction:column;align-items:center;gap:4px;border-radius:12px;background:${bgColor};padding:8px 12px;box-shadow:0 2px 8px rgba(0,0,0,0.15);white-space:nowrap;">
				${priceContent}
				${savingsHtml}
			</div>
			<div style="width:0;height:0;border-left:6px solid transparent;border-right:6px solid transparent;border-top:6px solid ${bgColor};"></div>
		</div>
	`;
};

export default createStationMarkerHtml;
